import React from 'react';
import { Button, Modal } from 'antd';
import CancelServiceForm from './CancelServiceForm';

interface IProps {
  id: string;
  visible: boolean;
  hide: () => any;
}

const CancelService: React.FC<IProps> = (props: IProps) => {
  const dismissModal = () => {
    props.hide();
  };

  return (
    <Modal
      destroyOnClose={true}
      centered={true}
      title={`Anular servicio ${props.id}`}
      visible={props.visible}
      onCancel={dismissModal}
      footer={[
        <Button onClick={() => props.hide()}>Cerrar</Button>,
        <Button
          form="cancel-service-form"
          key="submit"
          htmlType="submit"
          type={'primary'}
        >
          Anular servicio
        </Button>,
      ]}
    >
      <CancelServiceForm serviceId={props.id} />
    </Modal>
  );
};

export default CancelService;
